import clsx from 'clsx';

/**
 * Small "N" badge marking a Section or Subsection a reviewer added in the
 * assembly view (Figma node 1061-108006). Rendered in the title-suffix slot
 * when a node's `origin === 'novel'`. Uses the shared novel/instructive blue
 * (#515FFC) — the SAME colour as the "Instructive" pill and the novel
 * provenance chips, so every novel pill reads identically. The bare "N" glyph
 * is disambiguated for assistive tech by the aria-label.
 */
export function NovelBadge() {
  return (
    <span
      data-tone="novel"
      aria-label="Novel — added by reviewer"
      title="Novel"
      className={clsx(
        'inline-flex items-center gap-1 whitespace-nowrap rounded-pill',
        'px-[10px] py-1 text-xs font-semibold leading-none',
        'bg-[#515ffc]/15 text-[#515ffc]',
      )}
    >
      N
    </span>
  );
}
